import React from 'react';
import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import CheckboxFilter from '../components/explore/filters/CheckboxFilter/index';
import SliderFilter from '../components/explore/filters/SliderFilter/index';
import StarRating from '../components/shared/StarRating/index';
import RadioFilter from '../components/explore/filters/RadioFilter/index';
import CloudToggleFilter from '../components/explore/filters/CloudToggleFilter/index';

const FilterBarUtil = {
  checkboxFilterHandler(props, currentFilter) {
    return optionValue => {
      return () => {
        props.handleFilterToggle(currentFilter.key, optionValue);
      };
    };
  },
  isFilterInSetActive(filterConfig) {
    let isActive = 0;
    for (const key in filterConfig) {
      if (filterConfig[key].selected) {
        isActive++;
      }
    }
    return isActive;
  },
  sliderFilterHandler(props, currentFilter) {
    return (event, convertedValues) => {
      props.handleFilterSlider(currentFilter.key, convertedValues);
    };
  },
  isSliderFilterActive(filterConfig) {
    let isActive = 0;
    if (filterConfig.initialRange[0] != filterConfig.displayValue[0] || filterConfig.initialRange[1] != filterConfig.displayValue[1]) {
      isActive = 1;
    }
    return isActive;
  },
  ratingFilterHandler(props, currentFilter) {
    return (event, newValue) => {
      props.handleFilterSet(currentFilter.key, newValue);
    };
  },
  isRatingFilterActive(filterConfig) {
    return filterConfig ? 1 : 0;
  },
  sortFilterHandler(props, filterIndex) {
    return key => {
      return event => {
        props.handleSortFilterClick(key);
      };
    };
  },
  cloudFilterHandler(props, currentFilter) {
    const filterKey = currentFilter.key;
    return optionKey => {
      return event => {
        props.handleFilterToggle(filterKey, optionKey);
      };
    };
  },
  getFilterComponentByType(props, mappedFilter) {
    const filterTypesMap = {
      checkbox: {
        component: CheckboxFilter,
        handler: this.checkboxFilterHandler(props, mappedFilter),
        isActive: this.isFilterInSetActive
      },
      slider: {
        component: SliderFilter,
        handler: this.sliderFilterHandler(props, mappedFilter),
        isActive: this.isSliderFilterActive
      },
      rating: {
        component: StarRating,
        handler: this.ratingFilterHandler(props, mappedFilter),
        isActive: this.isRatingFilterActive
      },
      sort: {
        component: RadioFilter,
        handler: this.sortFilterHandler(props, mappedFilter),
        isActive: () => {
          0;
        }
      },
      cloud: {
        component: CloudToggleFilter,
        handler: this.cloudFilterHandler(props, mappedFilter),
        isActive: this.isFilterInSetActive
      }
    };
    return filterTypesMap[mappedFilter.type];
  },
  getFilterContent(props, filter, filterId) {
    const currentFilter = this.getFilterComponentByType(props, filter);
    const FilterComponent = currentFilter.component;
    return {
      active: currentFilter.isActive(filter.config),
      component: (
        <FilterComponent
          filterId={filterId}
          variant={filter.variant}
          config={filter.config}
          handler={currentFilter.handler}
          context={props.context}
        />
      )
    };
  }
};

export { FilterBarUtil };
